import { render, staticRenderFns } from "./ImprintCard.vue?vue&type=template&id=29a54b0e&"
import script from "./ImprintCard.vue?vue&type=script&lang=js&"
export * from "./ImprintCard.vue?vue&type=script&lang=js&"
import style0 from "./ImprintCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports